export default {
  documentTitle: '邀请好友赚奖励',
}
